<template>
  <div>
    <h3 class="title is-3">Games calendar</h3>
    <p>A quick look at past and coming games. Hover on the calendar for more information.</p>


    <div class="text-center section">
      <div class="checkbox-archives">
        <b-checkbox v-model="includeArchives" @input="repopulateCalendar">Include archived games</b-checkbox>
      </div>
      <v-calendar
          :attributes="attributes"
          :columns="3"
          :masks="masks"
          is-expanded
      >
      </v-calendar>
    </div>

    <h3 class="title is-5">Legend</h3>
    <span style="padding: 5px"><span class="circle circle-today">05</span><span>Today</span></span>
    <span style="padding: 5px"><span class="circle circle-blue">10</span><span>New game</span></span>
    <span style="padding: 5px"><span class="circle circle-green">17</span><span>Game playing</span></span>
    <span style="padding: 5px"><span class="circle circle-red">21</span><span>Game stopped</span></span>
    <span style="padding: 5px"><span class="circle circle-gray">25</span><span>Game archived</span></span>

  </div>
</template>

<script>
import displayHelper from '@/helpers/display-helper'
import gamesService from '@/services/gamesService'
import gameHelper from '@/helpers/game-helper'

export default {
  name: 'CalendarGames',
  created() {
    this.loadGameList()
  },
  data() {
    const month = new Date().getMonth()
    const year = new Date().getFullYear()
    return {
      masks: {
        weekdays: 'WWW',
      },
      attributes: [],
      includeArchives: false,
    }
  },
  methods: {
    loadGameList() {
      var parent = this
      this.loadGames()
          .then(() => {
            return this.populateCalendar()
          })
          .catch((err) => {
            displayHelper.displayError(parent, 'Oops, there was an error: ' + err.message())
          })
    },
    loadGames() {
      this.isLoading = true
      const parent = this
      return gamesService.getGames(this.includeArchives).then((games) => {
        this.games = gameHelper.formatGames(games)
        this.isLoading = false
      })
          .catch((error) => {
            displayHelper.displayError(parent, 'Oops, there was an error while loading the games: ' + error.message)
            this.isLoading = false
          })
    },
    repopulateCalendar() {
      this.attributes = []
      this.loadGameList()
    },
    populateCalendar() {
      const dateOfTheDayAttr = {
        key: 0,
        highlight: {
          color: 'purple',
          fillMode: 'outline'
        },
        dates: new Date()
      }
      this.attributes.push(dateOfTheDayAttr)

      for (let i = 0; i < this.games.length; i++) {
        const game = this.games[i]
        let highlightColor = 'blue'

        let startDate = game.gameStartRawDate
        let endDate = game.gameEndRawDate

        if (startDate) {
          startDate = new Date(startDate)
        }
        if (endDate) {
          endDate = new Date(endDate)
        }

        if (game.isArchived) {
          highlightColor = 'gray'
        }
        if (!game.isArchived && game.gameStatus === 'stopped') {
          highlightColor = 'red'
        }
        if (game.gameStatus === 'playing') {
          highlightColor = 'green'
        }

        let attr = {
          key: i,
          highlight: highlightColor,
          popover: {
            label: game.gameName
          },
          dates: [
            {
              start: startDate,
              end: endDate,
            }
          ]
        }

        this.attributes.push(attr)
      }
    }
  }
}
</script>

<style scoped>
.checkbox-archives {
  text-align: right;
  margin-top: 10px;
}

.container > * {
  flex: 1;
}

.circle {
  border-radius: 50%;
  height: 18px;
  padding: 6px;
  margin: 5px;
  color: #ffffff;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  border: 1px solid #ffffff
}

.circle-blue {
  background: #2b6cb0;
}

.circle-green {
  background: #37a269
}

.circle-red {
  background: #e53e3e
}

.circle-gray {
  background: #718196
}

.circle-today {
  background: #FFFFFF;
  border: 2px solid #7957d5;
  color: #2c3e50;
}

</style>
